export default {
  title: "Bedrijfsnaam",
  input: {
    title: {
      base: "{{action}}",
      action: {
        update: "Bedrijfsnaam aanpassen",
        create: "Nieuw bedrijf invoeren",
      },
    },
    name: {
      label: "Naam"
    },
  },
}
